function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledReviewsComponent } from "./reviews-component.scss";
import StarsComponent from "components/core/stars/stars-component";
import Review from "components/core/review/review";
class ReviewsComponent extends PureComponent {
    renderReviews() {
        const { columnWidth, reviews } = this.props;
        return reviews.map((review, index)=>{
            return /*#__PURE__*/ _jsx("div", {
                className: "review-component-wrapper",
                style: {
                    width: columnWidth
                },
                children: /*#__PURE__*/ _jsx(Review, _object_spread({}, review))
            }, index);
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(StyledReviewsComponent, {
            className: "reviews-component",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "header-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "stars-component-wrapper",
                            children: /*#__PURE__*/ _jsx(StarsComponent, {})
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "title",
                            children: "Why teams love monday.com"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "reviews-wrapper",
                    children: this.renderReviews()
                })
            ]
        });
    }
}
export { ReviewsComponent as default };
ReviewsComponent.defaultProps = {
    columnWidth: "350px",
    reviews: []
};
